import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FlagBasedPreloadModulesStrategyService } from './core/services/flag-based-preload-module.service';
import { AuthGuard } from './modules/auth/services/auth.guard';

export const routes: Routes = [
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
    data: {
      preload: true,
    },
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./_metronic/layout/layout.module').then((m) => m.LayoutModule),
    data: {
      preload: true,
    },
  },

  { path: '**', redirectTo: 'error/404', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: FlagBasedPreloadModulesStrategyService,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
